import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import styles from './styles.module.scss';
import { withTranslation } from 'next-i18next';
import withRouter from 'src/shared/utils/withRouter';

class IconGrid extends React.PureComponent {
    render() {
        const { children, src, width, height, baseLang, multiLang, className, iconClassName, router } = this.props;
        const fadeProps = {
            'data-aos': 'fade-up',
            'data-aos-duration': 500,
            'data-aos-once': true,
        };

        let imageSrc = src || '';
        if (multiLang && router && router.locale) {
            if (this.props[`src-${router.locale}`]) {
                imageSrc = this.props[`src-${router.locale}`];
            } else if (router.locale !== baseLang) {
                imageSrc = imageSrc.replace(/(\.[\w\d_-]+)$/i, `_${router.locale}$1`);
            }
        }

        return (
            <div className={`${styles.container} ${className}`} {...fadeProps}>
                <img className={`${styles.icon} ${iconClassName}`} height={height} width={width} src={imageSrc} />
                {children}
            </div>
        );
    }
}

export default compose(withTranslation(), withRouter)(IconGrid);

IconGrid.defaultProps = {
    src: '',
    width: 'auto',
    height: '60px',
    className: '',
    iconClassName: '',
};

IconGrid.propTypes = {
    src: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
};
